import colors from '@Common/assets/colors';
import showToast from '@Common/toast/showToast';
import { useGeneratorContext } from '@Context/GeneratorContext';
import { useQueueContext } from '@Context/QueueContext';
import { useTestCaseContext } from '@Context/TestCaseContext';
import { parseRequirements } from '@Generator/history/GenColumns';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { BounceLoader } from 'react-spinners';

interface Props {
  onClose: () => void;
}

const Instructions: React.FC<Props> = ({ onClose }) => {
  const [instruction, setInstruction] = useState('');
  const [loading, setLoading] = useState(false);

  const { regenerateTestCases } = useGeneratorContext();
  const { addToQueue } = useQueueContext();
  const { selectedGenerated, setViewType, setPanelOpen } = useTestCaseContext();

  const requirements = parseRequirements(selectedGenerated!.requirements);

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const input = e.target.value;
    if (input.length <= 200) {
      setInstruction(input);
    }
  };

  const handleSubmit = async () => {
    const id = selectedGenerated!.id;
    const instructions = instruction;

    if (instruction === '' || !instruction) {
      toast.error('Instructions cannot be empty');
    } else {
      showToast.info('Regenerating Test Cases', 'regenerate-tc');
      setLoading(true);
      const queue = await regenerateTestCases(id, instructions, requirements);
      if (queue) {
        addToQueue(queue.queueId, false);
      } else {
        toast.error('Regenerate Error!');
      }
      setViewType('');
      setPanelOpen(false);
      setLoading(false);
      onClose();
    }
  };

  return (
    <div>
      <textarea
        maxLength={200}
        value={instruction}
        disabled={loading}
        onChange={handleInputChange}
        placeholder="Enter your instructions here..."
        className="h-32 w-full resize-none rounded-md border border-gray-300 p-2 focus:outline-none focus:ring-2 focus:ring-primary-500"
      ></textarea>
      <div className="mb-2 text-right text-sm text-gray-600">
        {200 - instruction.length} characters remaining
      </div>

      {/* Footer */}
      <div className="mt-4 flex justify-end">
        {loading ? (
          <div className="flex flex-row items-center gap-x-2">
            <BounceLoader size={25} color={colors.brandWarning[500]} />
            <label>Regenerating</label>
          </div>
        ) : (
          <button
            className="rounded bg-primary-700 px-4 py-2 text-sm font-medium text-white hover:bg-primary-500"
            onClick={handleSubmit}
          >
            Regenerate
          </button>
        )}
      </div>
    </div>
  );
};

export default Instructions;
